import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=5682772a&scoped=true&"
import script from "./Videos.vue?vue&type=script&lang=ts&"
export * from "./Videos.vue?vue&type=script&lang=ts&"
import style0 from "./Videos.vue?vue&type=style&index=0&id=5682772a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5682772a",
  null
  
)

export default component.exports